import { useEffect, useState } from 'react';

import { MeetingProvider } from '@videosdk.live/react-sdk';

import { LeaveScreen } from './components/screens/LeaveScreen';
import { JoiningScreen } from './components/screens/JoiningScreen';
import { ILSContainer } from './interactive-live-streaming/ILSContainer';
import { MeetingAppProvider } from './MeetingAppContextDef';
import Loader from './components/Loader';
import { validateMeeting } from './api';
import WaitingToJoinScreen from './components/screens/WaitingToJoinScreen';
import {
  BRAVO_SITE_URLS,
  COUNTRIES_BY_LOCALE,
  MEETING_STATUSES,
} from './utils/constants';

const App = ({ locale }) => {
  const [token, setToken] = useState(null);
  const [meetingId, setMeetingId] = useState('');
  const [participantName, setParticipantName] = useState('');
  const [micOn, setMicOn] = useState(true);
  const [webcamOn, setWebcamOn] = useState(true);
  const [customAudioStream, setCustomAudioStream] = useState(null);
  const [customVideoStream, setCustomVideoStream] = useState(null);
  const [booting, setBooting] = useState(true);
  const [meetingStatus, setMeetingStatus] = useState(MEETING_STATUSES.NONE);

  const isMobile = window.matchMedia(
    'only screen and (max-width: 768px)',
  ).matches;

  const bravoSiteUrl = BRAVO_SITE_URLS[locale];
  const country = COUNTRIES_BY_LOCALE[locale];

  useEffect(() => {
    if (isMobile) {
      window.onbeforeunload = () => {
        return 'Are you sure you want to exit?';
      };
    }
  }, [isMobile]);

  useEffect(() => {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const [roomId] = pathSegments;

    if (!roomId) {
      setMeetingStatus(MEETING_STATUSES.NONE);
      setBooting(false);
      return;
    }

    setMeetingId(roomId);

    const checkRoom = async () => {
      const result = await validateMeeting({ roomId: roomId });

      if (result && result.room_id === roomId && result.status === 'valid') {
        setMeetingStatus(MEETING_STATUSES.VALID);
        setToken(result.token);
      } else {
        setMeetingStatus(MEETING_STATUSES.INVALID);
      }

      setBooting(false);
    };

    if (token === null) {
      checkRoom();
    }

    if (token === undefined) {
      setMeetingStatus(MEETING_STATUSES.INVALID);
      setBooting(false);
    }
  }, [token]);

  return (
    <>
      {booting ? (
        <Loader />
      ) : (
        <MeetingAppProvider>
          {meetingStatus === MEETING_STATUSES.STARTED && token && meetingId ? (
            <MeetingProvider
              config={{
                meetingId,
                micEnabled: micOn,
                webcamEnabled: webcamOn,
                name: participantName ? participantName : 'Visitante',
                customCameraVideoTrack: customVideoStream,
                customMicrophoneAudioTrack: customAudioStream,
                multiStream: true,
              }}
              token={token}
              reinitialiseMeetingOnConfigChange={true}
              joinWithoutUserInteraction={true}
            >
              <ILSContainer
                onMeetingLeave={() => {
                  setToken(undefined);
                  setMeetingId('');
                  setParticipantName('');
                  setWebcamOn(false);
                  setMicOn(false);
                  setMeetingStatus(MEETING_STATUSES.LEFT);
                  const newUrl =
                    locale !== 'es-MX' ? `/?country=${country}` : '/';
                  window.history.pushState({}, '', newUrl);
                }}
                bravoSiteUrl={bravoSiteUrl}
              />
            </MeetingProvider>
          ) : [MEETING_STATUSES.LEFT, MEETING_STATUSES.NONE].includes(
              meetingStatus,
            ) ? (
            <LeaveScreen bravoSiteUrl={bravoSiteUrl} />
          ) : meetingStatus === MEETING_STATUSES.VALID ? (
            <JoiningScreen
              participantName={participantName}
              setParticipantName={setParticipantName}
              setMicOn={setMicOn}
              setWebcamOn={setWebcamOn}
              onClickStartMeeting={() => {
                if (!meetingId) {
                  console.warn('No hay room_id en la URL');
                  return;
                }
                if (!token) {
                  console.warn('No hay token configurado');
                  return;
                }
                setMeetingStatus(MEETING_STATUSES.STARTED);
              }}
              setCustomAudioStream={setCustomAudioStream}
              setCustomVideoStream={setCustomVideoStream}
              micOn={micOn}
              webcamOn={webcamOn}
            />
          ) : (
            <WaitingToJoinScreen
              timeoutMs={10000}
              bravoSiteUrl={bravoSiteUrl}
            />
          )}
        </MeetingAppProvider>
      )}
    </>
  );
};

export default App;
